import { render } from "./AddressesSection.vue?vue&type=template&id=b8d16a80"
import script from "./AddressesSection.vue?vue&type=script&lang=js"
export * from "./AddressesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__